/**
 * 口座振替依頼返却情報一覧取得API
 * リクエスト - リクエスト業務エリア
 */

export interface Sgkd030aRequestDto {
  /** 口座振替日 */
  frikaedate?: string;
  /** 依頼返却締切日 */
  reqretDeadline?: string;
  /** 依頼返却金融機関コード */
  reqretFinancialinstitutioncode?: string;
  /** 出力済依頼返却表示フラグ */
  outputfinishRequestreturndisplayFlg?: string;
}
